import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import { homeIcons } from "../Home/homeIcons";
import { helpLabel, industries } from "./industriesContent";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

/* One card per industry. Each carries its own service list and its own
   "How We Help" list — the second sits on a tinted panel so the two never read
   as one long run of ticks. */
const IndustriesGrid = () => (
  <section className="bg-gray-50 py-14 lg:py-20" aria-label="Industries we serve">
    <div className="brand-col">
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 lg:grid-cols-2 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.05 }}
        variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
      >
        {industries.map((industry) => {
          const Icon = homeIcons[industry.icon];
          return (
            <motion.li
              key={industry.id}
              id={industry.id}
              style={{ scrollMarginTop: "7rem" }}
              variants={cardVariants}
              className="brand-card p-6 lg:p-8"
            >
              <div className="flex items-start gap-4">
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                  <Icon aria-hidden="true" className="h-5 w-5" />
                </span>
                <div className="min-w-0">
                  <h2 className="text-lg lg:text-xl font-bold text-gray-900">
                    {industry.title}
                  </h2>
                  <p className="mt-1 text-sm md:text-base font-semibold text-[var(--brand-primary)]">
                    {industry.subtitle}
                  </p>
                </div>
              </div>

              <p className="mt-5 text-sm md:text-base leading-relaxed text-gray-600">
                {industry.description}
              </p>

              <p className="mt-5 text-sm font-semibold text-gray-900">
                {industry.servicesLabel}
              </p>
              <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
                {industry.services.map((service) => (
                  <li key={service} className="flex items-start gap-3">
                    <FiCheckCircle
                      aria-hidden="true"
                      size={18}
                      className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
                    />
                    <span className="text-sm md:text-base text-gray-700">
                      {service}
                    </span>
                  </li>
                ))}
              </ul>

              {/* mt-auto pins this block to the bottom of the card, so the
                  panels line up across a row whatever each list runs to */}
              <div className="mt-auto pt-6">
                <div className="rounded-xl bg-[rgba(104,46,146,0.05)] p-4 sm:p-5">
                  <p className="text-sm font-semibold text-gray-900">
                    {helpLabel}
                  </p>
                  <ul className="mt-3 space-y-2">
                    {industry.help.map((item) => (
                      <li key={item} className="flex items-start gap-3">
                        <span
                          aria-hidden="true"
                          className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[var(--brand-orange)]"
                        />
                        <span className="text-sm md:text-base text-gray-700">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default IndustriesGrid;
